module.exports = __webpack_public_path__ + "static/oes_hardware.6796ba18.png";